// extracted by mini-css-extract-plugin
export var container = "styles-module--container--9d414";
export var containerRelative = "styles-module--containerRelative--3d5a4";